export const EMAIL_REGEX = RegExp(
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
);
export const PASSWORD_VALUE_REGEX = RegExp(
  "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{4,})"
);
export const LETTERS_REGEX = RegExp("^[A-Za-z]+$");
export const NUMBER_REGEX = RegExp("^[0-9]*$");
export const PHONE_US_REGEX = RegExp(/^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/);
